<template>
  <v-dialog v-model="pModelDialog" max-width="1600px" class="noMargin">
    <div>
      <v-toolbar dark class="secondaryColorBackground">
        <v-toolbar-title>{{ this.$t('dialogInfoPedido') }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon dark @click="fClose">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card flat class="px-2" height="120">
        <v-layout row wrap justify-center class="statusInfoBig" fill-height>
          <v-flex v-for="items in loadAllOrderWebStatusSync()" :key="items.id"
            :class="[getStatusWebCode(dPedidosDetalles.estadoPedido) === items.id ? 'statusLine' : 'statusLineAlt']"
            text-xs-center px-2 shrink my-auto>
            <v-avatar :class="[getStatusWebCode(dPedidosDetalles.estadoPedido) === items.id ? 'avatar' : 'avatarAlt']">
              <v-icon v-if="getStatusWebCode(dPedidosDetalles.estadoPedido) === items.id" dark>
                {{ getStatusWebIcono(dPedidosDetalles.estadoPedido) }}
              </v-icon>
            </v-avatar>
            <p class="mb-0">{{ getStatusWebCodeDescripcion(items.id) }}</p>
          </v-flex>
        </v-layout>
      </v-card>
      <v-card flat class="pt-0 pb-5">
        <v-card-text class="pa-0">
          <v-container fluid grid-list-md>
            <v-dialog v-model="dMostrarLoading" hide-overlay persistent width="300">
              <v-card class="datModalTitleContainer" dark>
                <v-card-text>
                  <div v-if="dGenerandoOC">
                    {{ $t('generandoOrdenCompra') }}
                  </div>
                  <div v-else>
                    {{ $t('cargandoContenido') }}
                  </div>
                  <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
                </v-card-text>
              </v-card>
            </v-dialog>
            <v-layout
              :class="{ 'justify-center row wrap pb-4 px-5': dScreenWidth > 1200, 'justify-center row wrap pb-3': dScreenWidth < 1200 }">
              <v-flex xs12 sm7 lg4 :class="{ 'px-5': dScreenWidth > 1200, 'px-4': dScreenWidth < 1200 }">
                <v-card class="px-0 secondaryThinBorder cardBoxShadow">
                  <v-card-title class="py-2 pl-2">
                    <p class="mb-0 title py-0">{{ $t('datosGenerales') }}</p>
                  </v-card-title>
                  <v-divider></v-divider>
                  <v-flex>
                    <v-layout row wrap>
                      <v-flex xs12 sm4 class="pl-2 dataTextOnModal text-xs-center text-sm-center">{{ $t('numeroPedido')
                      }}: </v-flex>
                      <v-flex xs12 sm8 class="dataBoldTextOnModal text-xs-center text-sm-center">{{
                        dPedidosDetalles.numPedido }}</v-flex>
                    </v-layout>
                  </v-flex>
                  <v-flex class="altRow">
                    <v-layout row wrap>
                      <v-flex xs12 sm4 class="pl-2 dataTextOnModal text-xs-center text-sm-center">{{ $t('codigoCliente')
                      }}: </v-flex>
                      <v-flex xs12 sm8 class="dataBoldTextOnModal text-xs-center text-sm-center">{{
                        dPedidosDetalles.clteID }}</v-flex>
                    </v-layout>
                  </v-flex>
                  <v-flex>
                    <v-layout row wrap>
                      <v-flex xs12 sm3 class="pl-2 dataTextOnModal text-xs-center text-sm-center">{{ $t('nombre') }}:
                      </v-flex>
                      <v-flex xs12 sm9 class="dataBoldTextOnModal text-xs-center text-sm-center">{{
                        dPedidosDetalles.clteNombre }}</v-flex>
                    </v-layout>
                  </v-flex>
                  <v-flex class="altRow">
                    <v-layout row wrap>
                      <v-flex xs12 sm3 class="pl-2 dataTextOnModal text-xs-center text-sm-center">{{ $t('razonSocial')
                      }}:
                      </v-flex>
                      <v-flex xs12 sm9 class="dataBoldTextOnModal text-xs-center text-sm-center">{{
                        dPedidosDetalles.razonSocial }}</v-flex>
                    </v-layout>
                  </v-flex>
                  <v-flex v-if="dHeaderDomain === 'CHAVES' || dHeaderDomain === 'CHAVES'">
                    <v-layout row wrap>
                      <v-flex xs12 sm3 class="pl-2 dataTextOnModal text-xs-center text-sm-center">{{ $t('referencia')
                      }}:
                      </v-flex>
                      <v-flex xs12 sm9 class="dataBoldTextOnModal text-xs-center text-sm-center">{{
                        dPedidosDetalles.referenciaLineal }}</v-flex>
                    </v-layout>
                  </v-flex>
                  <v-flex v-else>
                    <v-layout row wrap>
                      <v-flex xs12 sm3 class="pl-2 dataTextOnModal text-xs-center text-sm-center">{{ $t('referencia')
                      }}:
                      </v-flex>
                      <v-flex xs12 sm9 class="dataBoldTextOnModal text-xs-center text-sm-center">{{
                        dPedidosDetalles.refPedido }}</v-flex>
                    </v-layout>
                  </v-flex>
                </v-card>
              </v-flex>
              <v-flex xs12 sm6 lg4 :class="{ 'px-5': dScreenWidth > 1200, 'px-3': dScreenWidth < 1200 }">
                <v-card class="secondaryThinBorder cardBoxShadow px-0">
                  <v-card-title class="py-2 pl-2">
                    <p class="mb-0 title py-0">{{ $t('datosEnvio') }}</p>
                  </v-card-title>
                  <v-divider></v-divider>

                  <v-flex class="altRow">
                    <v-layout row wrap>
                      <v-flex xs12 sm3 class="pl-2 dataTextOnModal text-xs-center text-sm-center">{{ $t('nombre') }}:
                      </v-flex>
                      <v-flex xs12 sm9 class="dataBoldTextOnModal text-xs-center text-sm-center">
                        <span v-if="dLineasPedidoDetalle[0]">{{ dLineasPedidoDetalle[0].razonSocial }}</span>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                  <v-flex>
                    <v-layout row wrap>
                      <v-flex xs12 sm3 class="pl-2 dataTextOnModal text-xs-center text-sm-center">{{ $t('direccion') }}:
                      </v-flex>
                      <v-flex xs12 sm9 class="dataBoldTextOnModal text-xs-center text-sm-center">{{
                        dPedidosDetalles.direccionEnvio }}</v-flex>
                    </v-layout>
                  </v-flex>
                  <v-flex class="altRow">
                    <v-layout row wrap>
                      <v-flex xs12 sm3 class="pl-2 dataTextOnModal text-xs-center text-sm-center">{{ $t('poblacion') }}:
                      </v-flex>
                      <v-flex xs12 sm9 class="dataBoldTextOnModal text-xs-center text-sm-center">{{
                        dPedidosDetalles.poblacionEnvio }}</v-flex>
                    </v-layout>
                  </v-flex>
                  <v-flex>
                    <v-layout row wrap>
                      <v-flex xs12 sm3 class="pl-2 dataTextOnModal text-xs-center text-sm-center">{{ $t('telefono') }}:
                      </v-flex>
                      <v-flex xs12 sm8 class="pl-2 dataBoldTextOnModal text-xs-center"> {{
                        dPedidosDetalles.telefonoEnvio }}</v-flex>
                      <v-flex shrink class="py-0 pl-2 pr-0 text-xs-right">
                        <v-icon small @click="fDial(dPedidosDetalles.telefonoFacturacion)"
                          class="datSecondaryColor">call</v-icon>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                  <v-flex class="altRow">
                    <v-layout row wrap>
                      <v-flex xs12 sm3 class="pl-2 dataTextOnModal text-xs-center text-sm-center">{{ $t('email') }}:
                      </v-flex>
                      <v-flex xs12 sm8 class="pl-2 dataBoldTextOnModal text-xs-center"> {{ dDatosClientes.email
                      }}</v-flex>
                      <v-flex shrink class="py-0 pl-2 pr-0 text-xs-center">
                        <v-icon small @click="fSendmail(dDatosClientes.email)"
                          class="datSecondaryColor pr-0">mail</v-icon>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                  <v-flex>
                    <v-layout row wrap>
                      <v-flex xs12 sm5 class="pl-2 dataTextOnModal text-xs-center text-sm-center">{{
                        $t('agenciaTransporte') }}:
                      </v-flex>
                      <v-flex xs12 sm7 class="dataBoldTextOnModal text-xs-center text-sm-center">{{
                        dPedidosDetalles.agenciaTtte }}</v-flex>
                    </v-layout>
                  </v-flex>
                </v-card>
              </v-flex>
              <v-flex xs12 sm6 lg4 :class="{ 'px-5': dScreenWidth > 1200, 'px-3': dScreenWidth < 1200 }">
                <v-layout column>
                  <v-flex xs6 class="px-0">
                    <v-card class="px-0 cardBoxShadow secondaryThinBorder">
                      <v-card-title class="py-2 pl-2">
                        <p class="title mb-0 py-0">{{ $t('datosFacturacion') }}</p>
                      </v-card-title>
                      <v-divider></v-divider>

                      <v-flex class="altRow">
                        <v-layout row wrap>
                          <v-flex xs12 sm3 class="pl-2 dataTextOnModal text-xs-center text-sm-center">{{ $t('cif') }}:
                          </v-flex>
                          <v-flex xs12 sm9 class="dataBoldTextOnModal text-xs-center text-sm-center">{{
                            dPedidosDetalles.CIFFacturacion }}</v-flex>
                        </v-layout>
                      </v-flex>
                      <v-flex>
                        <v-layout row wrap>
                          <v-flex xs12 sm3 class="pl-2 dataTextOnModal text-xs-center text-sm-center">{{
                            $t('razonSocial') }}: </v-flex>
                          <v-flex xs12 sm9 class="dataBoldTextOnModal text-xs-center text-sm-center">
                            {{ dPedidosDetalles.razonSocial }}</v-flex>
                        </v-layout>
                      </v-flex>
                      <v-flex class="altRow">
                        <v-layout row wrap>
                          <v-flex xs12 sm3 class="pl-2 dataTextOnModal text-xs-center text-sm-center">{{ $t('direccion')
                          }}: </v-flex>
                          <v-flex xs12 sm9 class="dataBoldTextOnModal text-xs-center text-sm-center">{{
                            dPedidosDetalles.direccionFacturacion }}</v-flex>
                        </v-layout>
                      </v-flex>
                      <v-flex>
                        <v-layout row wrap>
                          <v-flex xs12 sm3 class="pl-2 dataTextOnModal text-xs-center text-sm-center">{{ $t('poblacion')
                          }}: </v-flex>
                          <v-flex xs12 sm9 class="dataBoldTextOnModal text-xs-center text-sm-center">{{
                            dPedidosDetalles.poblacionFacturacion }}</v-flex>
                        </v-layout>
                      </v-flex>
                      <v-flex class="altRow">
                        <v-layout row wrap>
                          <v-flex xs12 sm3 class="pl-2 dataTextOnModal text-xs-center text-sm-center">{{ $t('telefono')
                          }}: </v-flex>
                          <v-flex xs12 sm8 class="pl-2 dataBoldTextOnModal text-xs-center"> {{
                            dPedidosDetalles.telefonoEnvio }}</v-flex>
                          <v-flex shrink class="py-0 pl-2 pr-0 text-xs-center">
                            <v-icon small @click="fDial(dPedidosDetalles.telefonoFacturacion)"
                              class="datSecondaryColor">call</v-icon>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                      <v-flex>
                        <v-layout row wrap>
                          <v-flex xs12 sm3 class="pl-2 dataTextOnModal text-xs-center text-sm-center">{{ $t('email') }}:
                          </v-flex>

                          <v-flex xs12 sm8 class="pl-2 dataBoldTextOnModal text-xs-center"> {{ dDatosClientes.email
                          }}</v-flex>
                          <v-flex shrink class="py-0 pl-2 pr-0 text-xs-center">
                            <v-icon small @click="fSendmail(dDatosClientes.email)"
                              class="datSecondaryColor pr-0">mail</v-icon>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                    </v-card>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-container>

          <v-flex xs12 class="pl-4 pb-2">
            <v-card flat>
              <v-layout row wrap justify-space-between align-center>
                <v-flex>
                  <p class="title pt-2 pb-1 ">{{ $t('acciones') }}</p>
                  <v-btn small
                    v-if="dPedidosDetalles.tieneAlbaran && dPedidosDetalles.muestraAlbaranCab && getParametrizacionUsuario('consultaDocEstadoPedSN') === 'S'"
                    class="datPrimaryBtnOut" @click="fDescargarAlbaran">
                    <v-icon>
                      mdi-file-download-outline
                    </v-icon>
                    <span class="pl-2">{{ $t('descargarAlbaran') }}</span>
                  </v-btn>
                  <v-btn
                    v-if="dOrganizacion !== 63 && dNotOnPremise && dNotViso && dPedidosDetalles.numPedido != null && getParametrizacionUsuario('consultaDocEstadoPedSN') === 'S'"
                    small class="datPrimaryBtnOut" @click="fDescargarProforma">
                    <v-icon>
                      mdi-file-document-outline
                    </v-icon>
                    <span class="pl-2">
                      {{ $t('descargarProforma') }}
                    </span>
                  </v-btn>
                  <v-btn small
                    v-if="dPedidosDetalles.tieneFactura && dPedidosDetalles.muestraFacturaCab && getParametrizacionUsuario('consultaDocEstadoPedSN') === 'S'"
                    class="datPrimaryBtnOut" @click="fDescargarFactura">
                    <v-icon>
                      mdi-receipt
                    </v-icon>
                    <span class="pl-2">{{ $t('descargarFactura') }}</span>
                  </v-btn>
                  <v-btn small
                    v-if="dPedidosDetalles.tieneFactura && dPedidosDetalles.muestraFacturaCab && dParamsPedidos !== null && dParamsPedidos.showBtnDescargaCsv && getParametrizacionUsuario('consultaDocEstadoPedSN') === 'S'"
                    class="datPrimaryBtnOut" @click="fDescargarFacturaExcel">
                    <v-icon>
                      mdi-file-excel
                    </v-icon>
                    <span> {{ $t('facturaCsv') }}</span>
                  </v-btn>
                </v-flex>
                <v-flex v-if="isAdmin" shrink>
                  <v-btn small class="datPrimaryBtnOut" @click="fGenerarCompra">
                    <v-icon>
                      mdi-cart-plus
                    </v-icon>
                    <span>{{ $t('generarCompra') }}</span>
                  </v-btn>
                  <v-btn small class="datSecondaryBtn mr-2" @click="fToggleMarcarTodos">
                    <v-icon>
                      {{ dTodosMarcados ? 'mdi-checkbox-multiple-marked' : 'mdi-checkbox-multiple-blank-outline' }}
                    </v-icon>
                    <span>{{ dTodosMarcados ? $t('desmarcarTodos') : $t('marcarTodos') }}</span>
                  </v-btn>
                </v-flex>
              </v-layout>
            </v-card>
          </v-flex>

          <v-layout row wrap>
            <v-flex xs12 text-xs-center class="px-3">
              <v-data-table :headers="dIsChaves === true ? dHeadersChaves : dHeaders" :items="dLineasPedidoDetalle"
                :rows-per-page-text="this.$t('numPedidosPagina')" :pagination.sync="dPagination">
                <template v-slot:items="props">
                  <td class="text-xs-right">{{ props.item.articulo }}</td>
                  <td class="text-xs-left">{{ props.item.articuloNombre }}</td>
                  <td class="text-xs-right">{{ fFormatNumber(props.item.cantidad) }}</td>
                  <td class="text-xs-center statusInfo">
                    <span>
                      <template v-for="items in loadAllOrderWebStatusSync()">
                        <v-icon v-if="getStatusWebCode(props.item.estadoWeb) > items.id"
                          :key="items.id">mdi-checkbox-blank-circle </v-icon>
                        <v-icon v-if="getStatusWebCode(props.item.estadoWeb) === items.id" :key="items.id">
                          mdi-check-circle</v-icon>
                        <v-icon v-if="getStatusWebCode(props.item.estadoWeb) < items.id" :key="items.id">
                          mdi-checkbox-blank-circle-outline</v-icon>
                      </template>
                    </span>
                    <p class="mb-0">{{ getStatusWebDescripcion(props.item.estadoWeb) }}</p>
                  </td>
                  <td class="text-xs-left">{{ props.item.agenciaTransporte }}</td>
                  <td v-if="dIsChaves" class="text-xs-right">{{ props.item.referenciaLineal }}</td>
                  <td v-if="!dIsChaves" class="text-xs-right">{{ fGetDeliveryDate(props.item.estadoWeb,
                    props.item.fechaSituacion) |
                    moment(dFormatDate.default) }}</td>
                  <td v-if="isAdmin" class="text-xs-center" style="text-align: center;">
                    <v-checkbox :input-value="props.item.oCGeneradaSN === 'S'" disabled hide-details class="ma-0 pa-0"
                      style="display: inline-flex; justify-content: center;"></v-checkbox>
                  </td>
                  <td v-if="isAdmin" class="text-xs-center" style="text-align: center;">
                    <v-checkbox :input-value="props.item.generarOC === 'S'" @change="fToggleGenerarOC(props.item)"
                      :disabled="props.item.generarOC === 'S' && props.item.oCGeneradaSN === 'S'" hide-details
                      class="ma-0 pa-0" style="display: inline-flex; justify-content: center;"></v-checkbox>
                  </td>

                </template>
              </v-data-table>
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-card>
    </div>
  </v-dialog>
</template>
<script>
// UTILIDADES
import { abrirPestanaEnBlanco, cerrarPestana, descargarPdfsEnPestana } from '@/utils/utilDescargarPdf'

// SERVICIOS
import SrvImpresion from '@/services/srv-impresion'
import SrvOrdenesCompra from '@/services/srv-ordenes-compra'


export default {
  name: 'ShpPedidosDetalle',
  props: {
    pScreenWidth: {
      type: Number,
      required: true,
      default: 0
    },
    pParamsPedidos: {
      type: Object,
      required: false,
      default: null
    },
    pModelDialog: {
      type: Boolean,
      required: true,
      default: false
    },
    pLimitDate: {
      type: Object,
      required: false,
      default: {}
    }
  },
  data() {
    return {
      dPedidoDetalle: {},
      dDatosClientes: {},
      dScreenWidth: 0,
      dLineasPedidoDetalle: [],
      dParamsPedidos: {},
      dPedidosDetalles: [],
      dFormatDate: {
        'default': 'DD/MM/YYYY',
        'years': 'YYYY-MM-DD'
      },
      dLoadingPED: false,
      dGenerandoOC: false,
      dHeaderDomain: '',
      dOrganizacion: '',
      dRole: '',
      dNotOnPremise: true,
      dNotViso: true,
      dIsChaves: false,
      dHeaders: [],
      dHeadersChaves: [],
      dPagination: { 'rowsPerPage': 10 },
      dTodosMarcados: false
    }
  },
  computed: {
    isAdmin() {
      // Verificar si el role es ADMIN
      const isRoleAdmin = this.dRole === 'ADMIN'

      // Obtener datos de autenticación del store
      const datosAutenticacion = this.$store.getters.getAutenticacion


      // Verificar los campos adicionales
      const usuarioExpert = datosAutenticacion.usuarioExpertSN === 'S'
      const permiteCreaOC = this.getParametrizacionUsuario('permiteCreaOCSN') === 'S'

      return isRoleAdmin && usuarioExpert && permiteCreaOC
    },
    dMostrarLoading() {
      return this.dLoadingPED || this.dGenerandoOC
    }
  },
  created() {
    this.dHeaderDomain = localStorage.getItem('headerDomain')
  },
  mounted() {

    this.dRole = this.pLimitDate.roleUser

    this.dParamsPedidos = this.pParamsPedidos
    this.dNotOnPremise = localStorage.getItem('isOnPremise') !== 'yes'
    this.dOrganizacion = this.$store.getters.getUrlInfo.marca
    if (localStorage.getItem('headerDomain') === 'CHAVES' || localStorage.getItem('headerDomain') === 'CHAVESPR') {
      this.dIsChaves = true
    }
    if (localStorage.getItem('headerDomain') === 'JVISO' || localStorage.getItem('headerDomain') === 'JVISOERP2T1') {
      this.dNotViso = false
    }

    // Inicializar dScreenWidth desde el prop
    this.dScreenWidth = this.pScreenWidth || 0

    // Inicializar headers
    this.dHeaders = [
      { text: this.$t('articulo'), align: 'right', value: 'articulo', sortable: false },
      { text: this.$t('denominacion'), align: 'left', value: 'articuloNombre', sortable: false },
      { text: this.$t('cantidad'), align: 'right', value: 'cantidad', sortable: false },
      { text: this.$t('estado'), align: 'center', value: 'estadoWeb', sortable: false },
      { text: this.$t('agenciaTte'), align: 'left', value: 'agenciaTransporte', sortable: false },
      { text: this.$t('fechaExpedicion'), align: 'right', value: 'fechaEntrega', sortable: false }
    ]

    this.dHeadersChaves = [
      { text: this.$t('articulo'), align: 'right', value: 'articulo', sortable: false },
      { text: this.$t('denominacion'), align: 'left', value: 'articuloNombre', sortable: false },
      { text: this.$t('cantidad'), align: 'right', value: 'cantidad', sortable: false },
      { text: this.$t('estado'), align: 'center', value: 'estadoWeb', sortable: false },
      { text: this.$t('agenciaTte'), align: 'left', value: 'agenciaTransporte', sortable: false },
      { text: this.$t('suReferencia'), align: 'right', value: 'referenciaLineal', sortable: false }
    ]

    // Agregar columnas OC solo si es admin
    if (this.isAdmin) {
      this.dHeaders.push({ text: this.$t('ocGenerada'), align: 'center', value: 'ocGenerada', sortable: false })
      this.dHeaders.push({ text: this.$t('generarOC'), align: 'center', value: 'generarOc', sortable: false })
      this.dHeadersChaves.push({ text: this.$t('ocGenerada'), align: 'center', value: 'ocGenerada', sortable: false })
      this.dHeadersChaves.push({ text: this.$t('generarOC'), align: 'center', value: 'generarOc', sortable: false })
    }
  },
  watch: {
    pScreenWidth(newVal) {
      if (newVal) {
        this.dScreenWidth = newVal
      }
    }
  },
  methods: {
    fRecargarDatos(lineas, pedidos, clientes) {
      this.dLineasPedidoDetalle = lineas
      this.dPedidosDetalles = pedidos
      this.dDatosClientes = clientes
      this.dLoadingPED = false
      // Actualizar estado del botón marcar/desmarcar todos
      this.fActualizarEstadoTodosMarcados()
    },
    fLimpiarDatos() {
      this.dLoadingPED = true
      this.dLineasPedidoDetalle = []
      this.dPedidosDetalles = []
      this.dDatosClientes = {}
    },
    fDescargarAlbaran(linea) {
      const ventanaPdf = abrirPestanaEnBlanco()
      const albaranes = this.fEsLinea(linea)
        ? [{ 'numAlbaran': linea.numeroAlbaran, 'ejercicio': linea.numeroEjercicio }]
        : this.fAssignedAlbaranes()
      if (albaranes.length === 0) {
        cerrarPestana(ventanaPdf)
        this.$emit('alert', '<b>' + this.$t('notFacturaFound') + '</b><br/>' + this.$t('notFacturaFoundDesc'))
        return
      }
      this.fOpenAlbaranes(albaranes, ventanaPdf)
    },
    fGetEmpresaPedido(detallePedido = null) {
      if (detallePedido && detallePedido.clteEmpresa) {
        return detallePedido.clteEmpresa
      }
      if (this.dPedidosDetalles && this.dPedidosDetalles.clteEmpresa) {
        return this.dPedidosDetalles.clteEmpresa
      }
      if (this.dLineasPedidoDetalle && this.dLineasPedidoDetalle.length > 0 && this.dLineasPedidoDetalle[0].clteEmpresa) {
        return this.dLineasPedidoDetalle[0].clteEmpresa
      }
      return this.$store.getters.getAutenticacion.empresa
    },
    fClose() {
      this.$emit('close')
    },
    fGetDeliveryDate(situacion, fechaEntrega) {
      return (situacion === 0) ? null : fechaEntrega
    },
    /**
     * Indica si el parametro recibido es una linea concreta (llamada directa)
     * o el evento del boton (descarga de todos los documentos del pedido)
     */
    fEsLinea(linea) {
      return !!linea && linea.constructor === Object && Object.keys(linea).length !== 0
    },
    fMostrarErroresDescarga(errores, mensajePorDefecto) {
      if (errores.length > 0) {
        // Respuesta correcta del WS sin documento: se informa de que no existe en lugar de un mensaje vacio
        const mensajes = errores.map(error => error || mensajePorDefecto)
        this.$emit('alert', '<b>' + this.$t('errorDefault') + '</b><br> ' + mensajes.join('<br> '))
      }
    },
    fOpenAlbaranes(albaranes, ventanaPdf = null) {
      const peticiones = albaranes.map(albaran => () => {
        const payload = {
          tira: this.$store.getters.getAutenticacion.tira,
          empresa: this.$store.getters.getAutenticacion.empresa,
          tipoEmpresa: '0',
          pdfSn: 'S',
          ejercicio: albaran.ejercicio,
          albaranInicial: albaran.numAlbaran,
          albaranFinal: albaran.numAlbaran
        }
        return SrvImpresion.getReportAlbaran(payload).then(response => {
          const datos = (response && response.data) ? response.data : null
          // infoMsg.code puede llegar como numero (0) o como texto ('0')
          const codigoInfo = (datos && datos.infoMsg) ? String(datos.infoMsg.code) : ''
          if (datos && codigoInfo === '0' && datos.dataRes && String(datos.dataRes.errorCode) !== '-21001' && datos.dataRes.report) {
            return datos.dataRes.report
          }
          throw response
        })
      })
      const documentos = peticiones.map((obtener, indice) => ({ nombre: this.$t('albaran') + ' ' + albaranes[indice].numAlbaran, obtener: obtener }))
      descargarPdfsEnPestana(documentos, ventanaPdf, this.$t('albaranes')).then(errores => this.fMostrarErroresDescarga(errores, this.$t('notAlbaranFoundDesc')))
    },
    fAssignedInvoice() {
      const clavesFacturas = []
      const facturasObjects = []
      this.dLineasPedidoDetalle.forEach(linea => {
        // Las lineas pendientes de facturar llegan con numeroFactura = 0: no tienen factura que imprimir
        if (!(Number(linea.numeroFactura) > 0)) {
          return
        }
        const sinSecuencia = linea.secuenciaFactura === null || linea.secuenciaFactura === 'null' || linea.secuenciaFactura === undefined
        const numFactura = sinSecuencia ? linea.numeroFactura : linea.secuenciaFactura
        if (!(Number(numFactura) > 0)) {
          return
        }
        // Una misma factura agrupa varias lineas: se identifica por serie + numero
        const clave = String(linea.serieFactura) + '|' + String(numFactura)
        if (!clavesFacturas.includes(clave)) {
          clavesFacturas.push(clave)
          facturasObjects.push({
            'numFactura': numFactura,
            'representante': linea.representante,
            'cliente': linea.cliente,
            'fechaFactura': linea.fechaFactura,
            'serie': linea.serieFactura
          })
        }
      })
      return facturasObjects
    },
    fOpenFacturas(facturas, ventanaPdf = null) {
      const peticiones = facturas.map(factura => () => {
        const payload = {
          tira: this.$store.getters.getAutenticacion.tira,
          empresa: this.$store.getters.getAutenticacion.empresa,
          tipoEmpresa: '0',
          pdfSn: 'S',
          rpteIni: factura.representante,
          rpteFin: factura.representante,
          fechaIni: this.formatDate(factura.fechaFactura),
          fechaFin: this.formatDate(factura.fechaFactura),
          clteIni: factura.cliente,
          clteFin: factura.cliente,
          factFin: factura.numFactura,
          factIni: factura.numFactura
        }
        const serie = factura.serie
        if (serie !== null && serie !== undefined && serie !== 'null' && serie.length > 0) {
          payload.series = [{ serie: serie }]
        }
        return SrvImpresion.getURLFacturas(payload).then(response => {
          const datos = (response && response.data) ? response.data : null
          if (datos && datos.statusCode === '200' && datos.report) {
            return datos.report
          }
          throw response
        })
      })
      const documentos = peticiones.map((obtener, indice) => ({ nombre: this.fNombreFactura(facturas[indice]), obtener: obtener }))
      descargarPdfsEnPestana(documentos, ventanaPdf, this.$t('facturas')).then(errores => this.fMostrarErroresDescarga(errores, this.$t('notFacturaFoundDesc')))
    },
    fNombreFactura(factura) {
      const serie = (factura.serie !== null && factura.serie !== undefined && factura.serie !== 'null') ? factura.serie : ''
      return this.$t('factura') + ' ' + serie + factura.numFactura
    },
    fAssignedAlbaranes() {
      const numeroAlbaranes = []
      const albaranesObjects = []
      this.dLineasPedidoDetalle.forEach(linea => {
        // Las lineas sin albaranar llegan con numeroAlbaran = 0: no tienen albaran que imprimir
        if (!(Number(linea.numeroAlbaran) > 0)) {
          return
        }
        if (!numeroAlbaranes.includes(linea.numeroAlbaran)) {
          numeroAlbaranes.push(linea.numeroAlbaran)
          albaranesObjects.push({
            'numAlbaran': linea.numeroAlbaran,
            'ejercicio': linea.numeroEjercicio
          })
        }
      })
      return albaranesObjects
    },
    fDescargarFactura(linea) {
      // Pestana local a cada pulsacion: descargas simultaneas no comparten ni se pisan la pestana preabierta
      const ventanaPdf = abrirPestanaEnBlanco()
      let facturas
      if (this.fEsLinea(linea)) {
        const sinSecuencia = linea.secuenciaFactura === null || linea.secuenciaFactura === 'null' || linea.secuenciaFactura === undefined
        facturas = [{
          'numFactura': sinSecuencia ? linea.numeroFactura : linea.secuenciaFactura,
          'representante': linea.representante,
          'cliente': linea.cliente,
          'fechaFactura': linea.fechaFactura,
          'serie': linea.serieFactura
        }]
      } else {
        facturas = this.fAssignedInvoice()
      }
      if (facturas.length === 0) {
        cerrarPestana(ventanaPdf)
        this.$emit('alert', '<b>' + this.$t('notFacturaFound') + '</b><br/>' + this.$t('notFacturaFoundDesc'))
        return
      }
      this.fOpenFacturas(facturas, ventanaPdf)
    },
    fDescargarProforma() {
      const ventanaPdf = abrirPestanaEnBlanco()
      if (!this.dLineasPedidoDetalle || this.dLineasPedidoDetalle.length === 0) {
        cerrarPestana(ventanaPdf)
        return
      }
      const payload = {
        tira: this.$store.getters.getAutenticacion.tira,
        empresa: this.fGetEmpresaPedido(),
        tipoEmpresa: '0',
        pdfSn: 'S',
        help: 'N',
        numeroPedido: this.dLineasPedidoDetalle[0].numeroPedido,
        cliente: this.dLineasPedidoDetalle[0].cliente,
        E0: 0,
        E1: 1,
        E2: 2,
        E3: 3,
        E4: 4,
        E5: 5,
        E6: 6,
        E7: 7,
        E8: 8
      }
      const peticion = () => SrvImpresion.getDescargaProforma(payload).then(response => {
        const datos = (response && response.data) ? response.data : null
        if (datos && datos.errorMsg && datos.errorMsg.message) {
          throw new Error(datos.errorMsg.message)
        }
        if (datos && datos.dataRes && datos.dataRes.errorMsg) {
          throw new Error('Proforma no disponible ' + datos.dataRes.errorCode)
        }
        if (datos && datos.statusCode === '200' && datos.dataRes && datos.dataRes.report) {
          return datos.dataRes.report
        }
        throw response
      })
      descargarPdfsEnPestana([{ nombre: this.$t('descargarProforma'), obtener: peticion }], ventanaPdf).then(errores => this.fMostrarErroresDescarga(errores, this.$t('pdfNotFoundDesc')))
    },
    fRespuestaCorrecta(response) {
      let finalValue = false;
      if (response.status === 200 && response.data.result !== 'ko' && (response || response.data !== undefined || response.data.dataRes.result !== undefined || response.data.dataRes.result !== null)) {
        finalValue = true
      }
      return finalValue
    },
    fGenerarCompra() {

      try {
        // Verificar que haya al menos una línea seleccionada (generarOC === 'S')
        const lineasSeleccionadas = this.dLineasPedidoDetalle.filter(linea => linea.generarOC === 'S')

        if (lineasSeleccionadas.length === 0) {
          this.$emit('alert', '<b>' + this.$t('noLineasSeleccionadas') + '</b><br>' + this.$t('noLineasSeleccionadasDesc'))
          return
        }

        // Construir array con TODAS las líneas (tanto S como N)
        const lineasPayload = this.dLineasPedidoDetalle.map(linea => ({
          numeroLinea: linea.numeroLinea || linea.linea || '',
          marcado: linea.generarOC || 'N'
        }))

        const payload = {
          tira: this.$store.getters.getAutenticacion.tira,
          empresa: this.$store.getters.getAutenticacion.empresa,
          contabilidad: this.dLineasPedidoDetalle[0].contabilidad || '',
          cliente: this.dLineasPedidoDetalle[0].cliente,
          numeroPedido: this.dLineasPedidoDetalle[0].numeroPedido,
          lineas: lineasPayload
        }
        this.dGenerandoOC = true;
        SrvOrdenesCompra.generarOcPedido(payload).then(response => {
          this.dGenerandoOC = false;
          if (!this.fRespuestaCorrecta(response)) {
            throw new Error(response.data.errorMsg.message);
          }

          // Si la generación fue exitosa, actualizar el estado de las líneas seleccionadas
          lineasSeleccionadas.forEach(linea => {
            linea.oCGeneradaSN = 'S'
          })

          this.$emit('alert', '<b>' + this.$t('ocGeneradaExito') + '</b><br>' + response.data.dataRes.infoMsg)
        }).catch(error => {
          this.$emit('alert', '<b>' + this.$t('errorGenerarOC') + '</b><br>' + (error.message || this.$t('errorConexion')))
        })
      } catch (error) {
        this.$emit('alert', '<b>' + this.$t('errorProcesarSolicitud') + '</b><br>' + (error.message || this.$t('errorDesconocido')))
      }
    },
    fToggleGenerarOC(item) {
      // Cambiar el valor entre 'S' y 'N'
      item.generarOC = item.generarOC === 'S' ? 'N' : 'S'
      this.fActualizarEstadoTodosMarcados()
    },
    fToggleMarcarTodos() {
      // Obtener líneas que se pueden marcar/desmarcar (que no tienen OC generada)
      const lineasDisponibles = this.dLineasPedidoDetalle.filter(linea => linea.oCGeneradaSN !== 'S')

      if (lineasDisponibles.length === 0) {
        return // No hay líneas disponibles para marcar/desmarcar
      }

      const nuevoEstado = this.dTodosMarcados ? 'N' : 'S'

      // Aplicar el cambio a todas las líneas disponibles
      lineasDisponibles.forEach(linea => {
        linea.generarOC = nuevoEstado
      })

      // Actualizar el estado del botón
      this.fActualizarEstadoTodosMarcados()
    },
    fActualizarEstadoTodosMarcados() {
      // Obtener líneas que se pueden marcar (que no tienen OC generada)
      const lineasDisponibles = this.dLineasPedidoDetalle.filter(linea => linea.oCGeneradaSN !== 'S')

      if (lineasDisponibles.length === 0) {
        this.dTodosMarcados = false
        return
      }

      // Verificar si todas las líneas disponibles están marcadas
      const lineasMarcadas = lineasDisponibles.filter(linea => linea.generarOC === 'S')
      this.dTodosMarcados = lineasMarcadas.length === lineasDisponibles.length
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/Informes/Pedidos/ShpPedidosDetalle.vue